// extracted by mini-css-extract-plugin
export default {"container":"FatalErrorModal_container__wdYCK","header":"FatalErrorModal_header__D0q5H","button":"FatalErrorModal_button__al9xy"};